<fuse-app-lessons-tab class="page-layout simple  inner-scroll" fxFlex type="currentUser"></fuse-app-lessons-tab>
